module.exports = __webpack_public_path__ + "img/parada-de-autobus.b98c22fc.png";